import React from 'react';
import { inject, observer } from 'mobx-react';

import SongRow from './song-row';

@inject('artistStore', 'songsStore')
class AuditionSongList extends React.Component {
	render () {
		const { artistStore, songsStore } = this.props;
		const songList = songsStore
			.getSongsByArtistID(artistStore.data.artist.get('_id'));
		// const songCount	= songList.length;
		// console.log(artistStore.data.artist.name);

		return (
			<div className="grid-x grid-padding-x padding-top-2">
				<div className="cell">
					<h4>Audition Music ({ songList.length } songs)</h4>
					{
						songList.map((song) => (
							<SongRow key={ song._id } song={ song } />
						))
					}
				</div>
			</div>
		);
	}
}

export default AuditionSongList;
